module.exports = __webpack_public_path__ + "static/cars3-183fda99006b0c80712f2799118618f0.png";